import * as THREE from 'three';
import { Camera } from './index';

/* TriggerType
 * アニメーション起動のトリガータイプ.
 */
export enum TriggerType {
    none,
    standBefore,
    clickOn
}

/* AnimObject
 *
 */
export class AnimObject {
    public fps: number;

    public length: number; // sec

    public name: string;
}

// THREE.KeyFrameAnimationは既に廃止されているのでコメントアウト
// 同等の動作を行うアニメーションの実装が必要


/* KeyFrameAnimation
 * キーフレームアニメーションオブジェクト.
 */
export class KeyFrameAnimation {
    // private _kfAnimations: THREE.KeyFrameAnimation[];
    private _animActions: THREE.AnimationAction[];

    // private _animations: AnimObject[];
    private _animations: THREE.AnimationClip[];

    private _enabled: boolean;

    private _startTimeStamp: number;

    private _lastTimeStamp: number;

    private _maxDuration: number;

    private _name: string;    // itemInfoのnameが入っている(ユニーク) この名称でアニメーションが検索される

    private _mixer: THREE.AnimationMixer;

    private _obj: THREE.Group;

    private clock: THREE.Clock;

    public get type(): TriggerType { return TriggerType.none; }

    public get enabled(): boolean { return this._enabled; }

    public set enabled(value: boolean) { this._enabled = value; }

    public get name(): string { return this._name; }

    public get duration(): number { return this._lastTimeStamp - this._startTimeStamp; }

    public get maxDuration(): number { return this._maxDuration; }

    constructor(object: any) {
      this._obj = object.scene;
      this._animations = object.animations;
      this._enabled = false;
      this._startTimeStamp = 0;
      this._lastTimeStamp = 0;
      this._maxDuration = 0;
      this._name = object.scene.name;

      // 自動的にアニメーション再生しない
      this.clock = new THREE.Clock(false);

      if(this._animations && this._animations.length) {
        //Animation Mixerインスタンスを生成
        this._mixer = new THREE.AnimationMixer(this._obj);

        //全てのAnimation Clipに対して
        this._animActions = [];
        for (let i = 0; i < this._animations.length; i++) {
          const anim: THREE.AnimationClip = this._animations[i];

          // アニメーション再生時間の最大値を取得
          if(this._maxDuration < anim.duration) this._maxDuration = anim.duration;

          //Animation Actionを生成
          const action = this._mixer.clipAction(anim);
          //ループ設定（1回のみ）
          action.setLoop(THREE.LoopOnce, 1);
          //アニメーションの最後のフレームでアニメーションが終了
          action.clampWhenFinished = true;

          this._animActions.push(action);
        }

      }
    }

    /* start
     *
     */
    public start() {
      this.enabled = true;
      this._startTimeStamp = -1;
      this._lastTimeStamp = -1;

      this.setup();
      this.play();
    }

    /* play
     *
     */
    public play(index?: number) {
      //全てのAnimation Clipに対して
      for (let i = 0; i < this._animActions.length; i++) {
        const animation: THREE.AnimationAction = this._animActions[i];
        //アニメーションを再生
        animation.reset().play();
      }

      this.clock.start();
    }

    /* setup
     *
     */
    public setup() {
      ;
    }

    /* toFreeze
     *
     */
    public toFreeze(camera: Camera, timeStamp: number): boolean {
      return false;
    }

    /* update
     *
     */
    public update(camera: Camera, timeStamp: number) {
      if (!this.clock) return;

      const dt = this.clock.getDelta();

      this._mixer && this._mixer.update(dt);

      if(this.clock.getElapsedTime() > this._maxDuration) {
        this.clock.stop();
        this.enabled = false;
      }

      return;
    }
}

/* WalkThroughAnimation
 * ウォークスルーアニメーションオブジェクト.
 */
export class WalkThroughAnimation extends KeyFrameAnimation {
    private _type: TriggerType;

    private _position: THREE.Vector3;

    private _maxDist: number;

    private _minDist: number;

    public get type(): TriggerType { return this._type; }

    public set maxDist(value: number) { this._maxDist = value; }

    public set minDist(value: number) { this._minDist = value; }

    protected get position(): THREE.Vector3 { return this._position; }

    constructor(anims: any, position: THREE.Vector3, type: TriggerType) {
      super(anims);

      this._type = type;
      this._position = position;
      this._minDist = 0.1;
      this._maxDist = 3.0;
    }

    public isInRange(distance: number): boolean {
      return ((this._minDist < distance) && (distance < this._maxDist));
    }
}

